module.exports = __webpack_public_path__ + "static/36575D_1_0-cb94adf4bcb3ad1bd64ef6659daf7796.woff";